export default function UsersTableSkeleton() {
  return (
    <div className="mt-6 flow-root">
      <div className="inline-block min-w-full align-middle">
        <div className="rounded-lg bg-gray-50 p-2 md:pt-0">
          
          <div className="mb-2 w-full rounded-md bg-white p-4 lg:hidden">
            <div className="flex items-center justify-between border-b pb-4">
              <div>
                <div className="mb-2 flex items-center">
                  {/* <Image
                                  src={user.profileImage || "/default-profile.png"}
                                  className="mr-2 rounded-full"
                                  width={28}
                                  height={28}
                                  alt={`${user.name}'s profile picture`}
                                /> */}
                  <div className="h-6 w-32 rounded bg-gray-100"></div>
                </div>
              </div>
              <div className="flex items-center gap-2">
                <div className="h-6 w-16 rounded bg-gray-100"></div>{" "}
                {/* Skeleton for Role */}
                <div className="h-6 w-16 rounded bg-gray-100"></div>{" "}
                {/* Skeleton for Status */}
              </div>
            </div>
            <div className="flex w-full items-center justify-between pt-4">
              <div className="flex flex-row gap-2">
                <div className="h-6 w-16 rounded bg-gray-100"></div>

                <div className="h-6 w-16 rounded bg-gray-100"></div>
              </div>
              <div className="flex justify-end gap-2">
                <div className="h-6 w-16 rounded bg-gray-100"></div>

                <div className="h-6 w-16 rounded bg-gray-100"></div>
              </div>
            </div>
          </div>

          <table className="hidden min-w-full text-gray-900 lg:table">
            <thead className="rounded-lg text-left text-sm font-normal">
              <tr>
                <th scope="col" className="px-4 py-5 font-medium sm:pl-6">
                  Name
                </th>
                <th scope="col" className="px-3 py-5 font-medium">
                  Phone
                </th>
                <th scope="col" className="px-3 py-5 font-medium">
                  Role
                </th>
                <th scope="col" className="px-3 py-5 font-medium">
                  Status
                </th>
                
                <th scope="col" className="px-3 py-5 font-medium">
                  Created At
                </th>
                <th
                  scope="col"
                  className="relative pb-4 pl-3 pr-6 pt-2 sm:pr-6"
                >
                  <span className="sr-only">Edit</span>
                </th>
              </tr>
            </thead>
            <tbody className="bg-white">
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
              <TableRowSkeleton />
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export function TableRowSkeleton() {
  return (
    <tr className="w-full border-b border-gray-100 last-of-type:border-none [&:first-child>td:first-child]:rounded-tl-lg [&:first-child>td:last-child]:rounded-tr-lg [&:last-child>td:first-child]:rounded-bl-lg [&:last-child>td:last-child]:rounded-br-lg">
      {/* Customer Name and Image */}
      <td className="relative overflow-hidden whitespace-nowrap py-3 pl-6 pr-3">
        <div className="h-6 w-32 rounded bg-gray-100"></div>
      </td>
      {/* Phone */}
      <td className="whitespace-nowrap px-3 py-3">
        <div className="h-6 w-32 rounded bg-gray-100"></div>
      </td>
      {/* Role */}
      <td className="whitespace-nowrap px-3 py-3">
        <div className="h-6 w-16 rounded bg-gray-100"></div>
      </td>
      {/* Status */}
      <td className="whitespace-nowrap px-3 py-3">
        <div className="h-6 w-16 rounded bg-gray-100"></div>
      </td>
      
      {/* created at */}
      <td className="whitespace-nowrap px-3 py-3">
        <div className="h-6 w-16 rounded bg-gray-100"></div>
      </td>
      {/* Actions */}
      <td className="whitespace-nowrap py-3 pl-6 pr-3">
        <div className="flex justify-end gap-3">
          <div className="h-[38px] w-[38px] rounded bg-gray-100"></div>
          <div className="h-[38px] w-[38px] rounded bg-gray-100"></div>
        </div>
      </td>
    </tr>
  );
}
